/** SDK 嵌入时鉴权：主站 axios / WebSocket 均读 sessionStorage.token */

let fallbackToken = ''

export interface SdkAuthOptions {
  /** 写入 sessionStorage.token（request 拦截器会带到 header） */
  token?: string
  sessionStorage?: Record<string, string>
  /** 写入 localStorage.Workspace_id */
  workspaceId?: string
}

export function setSdkAuth (options: SdkAuthOptions): void {
  if (options.token?.trim()) {
    fallbackToken = options.token.trim()
    try {
      sessionStorage.setItem('token', fallbackToken)
    } catch {
      /* ignore */
    }
  }
  if (options.sessionStorage) {
    for (const [k, v] of Object.entries(options.sessionStorage)) {
      try {
        sessionStorage.setItem(k, v)
      } catch {
        /* ignore */
      }
    }
  }
  if (options.workspaceId?.trim()) {
    try {
      localStorage.setItem('Workspace_id', options.workspaceId.trim())
    } catch {
      /* ignore */
    }
  }
}

export function clearSdkAuth (): void {
  fallbackToken = ''
}

export function getSdkRequestToken (): string | null {
  try {
    return sessionStorage.getItem('token') || fallbackToken || null
  } catch {
    return fallbackToken || null
  }
}
